import { render, staticRenderFns } from "./AgentCompetitorsTable.vue?vue&type=template&id=23bc96f4&scoped=true&"
import script from "./AgentCompetitorsTable.vue?vue&type=script&lang=ts&"
export * from "./AgentCompetitorsTable.vue?vue&type=script&lang=ts&"
import style0 from "./AgentCompetitorsTable.vue?vue&type=style&index=0&id=23bc96f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc96f4",
  null
  
)

export default component.exports